// import Sentry React SDK
import instrument from '../src/React/Util/instrument';

import ReactOnRails from 'react-on-rails';
import AddNewsletterModal from '../src/React/Components/NewsletterModal/AddNewsletter';
import Admin from '../src/React/Pages/Admin/Admin';
import AffiliatePortfolio from '../src/React/Pages/Dashboard/AffiliatePortfolio';
import Article from '../src/React/Pages/Learn/Article';
import BenefitOfferAdminModal from '../src/React/Pages/BenefitOfferAdminModal/BenefitOfferAdminModal';
import BlogArticleAdminModal from '../src/React/Pages/BlogArticleAdminModal/BlogArticleAdminModal';
import BlogArticlesAdmin from '../src/React/Pages/BlogArticlesAdmin/BlogArticlesAdmin';
import BusinessProposalPage from '../src/React/Pages/BusinessProposal/BusinessProposal';
import CancellationSurvey from '../src/React/Components/CancellationSurvey/CancellationSurvey';
import CaseStudyAdminModal from '../src/React/Pages/CaseStudyAdminModal/CaseStudyAdminModal';
import CircularProgress from '../src/React/Components/Icons/CircularProgress';
import EntrepreneurDashboard from '../src/React/Pages/Dashboard/EntrepreneurDashboard';
import Faqs from '../src/React/Pages/Faq/Faq';
import FaqsHome from '../src/React/Pages/FaqsHome/FaqsHome';
import FinancialChart from '../src/React/Pages/FinancialChart/FinancialChart';
import FindInvestorsPage from '../src/React/Pages/FindInvestors/FindInvestors';
import Gallery from '../src/React/Pages/Gallery/Gallery';
import Hero from '../src/React/Components/Hero/Hero';
import Inbox from '../src/React/Pages/Inbox/Inbox';
import InboxRevamp from '../src/React/Pages/InboxRevamp/InboxRevamp';
import IndustryList from '../src/React/Pages/IndustryList/IndustryList';
import InvestorCardTwig from '../src/React/Pages/InvestorCardTwig/InvestorCardTwig';
import InvestorDashboard from '../src/React/Pages/Dashboard/InvestorDashboard';
import InvestorsPage from '../src/React/Pages/Investors/Investors';
import Learn from '../src/React/Pages/Learn/Learn';
import LearnArticleDataAdminModal from '../src/React/Pages/LearnArticleAdmin/LearnArticleDataAdminModal.jsx';
import LearnArticleContentAdminModal from '../src/React/Pages/LearnArticleAdmin/LearnArticleContentAdminModal';
import LearnEbookAdminModal from '../src/React/Pages/LearnEbookAdmin/LearnEbookAdminModal';
import LearnSubsectionAdminModal from '../src/React/Pages/LearnSubsectionAdmin/LearnSubsectionAdminModal';
import LearnSubPage from '../src/React/Pages/Learn/Subpage';
import MarqueeComponent from '../src/React/Pages/Marquee/Marquee';
import MyMatchesPage from '../src/React/Pages/MyMatches/MyMatches';
import MyPitchesPage from '../src/React/Pages/MyPitches/MyPitchesPage.tsx';
import NewsfeedAdmin from '../src/React/Pages/NewsfeedAdmin/NewsfeedAdmin';
import NewsfeedPage from '../src/React/Pages/Newsfeed/Newsfeed';
import Notification from '../src/React/Pages/Notification/Notification';
import PitchCreation from '../src/React/Pages/PitchCreation/PitchCreation';
import ProposalCarousel from '../src/React/Pages/ProposalCarousel/ProposalCarousel';
import ProposalCarouselBlock from '../src/React/Components/ProposalCarouselBlock/ProposalCarouselBlock';
import ProposalSummaryTwig from '../src/React/Pages/ProposalSummaryTwig/ProposalSummaryTwig';
import StatesSection from '../src/React/Pages/States/States';
import SwiperCarousel from '../src/React/Components/Swiper/Swiper';
import VideoPlayer from '../src/React/Components/Newsfeed/VideoPlayer';

ReactOnRails.register({
  AddNewsletterModal,
  Admin,
  AffiliatePortfolio,
  Article,
  BenefitOfferAdminModal,
  BlogArticleAdminModal,
  BlogArticlesAdmin,
  BusinessProposalPage,
  CancellationSurvey,
  CaseStudyAdminModal,
  CircularProgress,
  EntrepreneurDashboard,
  Faqs,
  FaqsHome,
  FinancialChart,
  FindInvestorsPage,
  Gallery,
  Hero,
  Inbox,
  InboxRevamp,
  IndustryList,
  InvestorCardTwig,
  InvestorDashboard,
  InvestorsPage,
  Learn,
  LearnArticleDataAdminModal,
  LearnArticleContentAdminModal,
  LearnEbookAdminModal,
  LearnSubsectionAdminModal,
  LearnSubPage,
  MarqueeComponent,
  MyMatchesPage,
  MyPitchesPage,
  NewsfeedAdmin,
  NewsfeedPage,
  Notification,
  PitchCreation,
  ProposalCarousel,
  ProposalCarouselBlock,
  ProposalSummaryTwig,
  StatesSection,
  SwiperCarousel,
  VideoPlayer
});
